<template>
<div class="container">
  <div class="row mb-2">
    <div class="col-auto">Rule Priority:</div>
    <input-number v-model="rule.priority" group-class="col-1"></input-number>
  </div>
  
  <div class="row mb-4 border bg-light">
    <div class="col-12 fw-bold fst-italic text-primary fs-5 bg-light">Conditions</div>
    <div class="col">
      <table class="table table-sm table-bordered">
        <thead class="table-dark small">
          <tr>
            <th width="30%">Attribute Name</th>
            <th width="10%">&nbsp;</th>
            <th width="55%">Condition Value</th>
            <th width="5%">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!rule.conditions || rule.conditions.length == 0">
            <td colspan="4" class="text-warning fw-bold py-2 text-center">No Conditions</td>
          </tr>
          <tr v-for="(cond, index) in rule.conditions" :key="index">
            <td>
              <select class="form-control form-control-sm" v-model="cond.attrName">
                <option value="cardNumber">Card Number</option>
                <option value="email">Email Address</option>
                <option value="amount">Amount</option>
                <option value="currency">Currency</option>
              </select>
            </td>
            <td>
              <select class="form-control form-control-sm" v-model="cond.condType">
                <option value="EQ">Equals</option>
                <option value="NE">Not Equals</option>
                <option value="LT">Less Than</option>
                <option value="LE">Less or Equal</option>
                <option value="GT">Greater Than</option>
                <option value="GE">Greater or Equal</option>
                <option value="STARTSWITH">Starts With</option>
                <option value="CONTAINS">Contains</option>
              </select>
            </td>
            <td><input class="form-control form-control-sm" type="text" v-model="cond.condValue"/></td>
            <td class="text-center"><a href="#"><i class="fas fa-trash-alt" @click="onDelCond(index)"></i></a></td>
          </tr>
          <tr>
            <td colspan="3">&nbsp;</td>
            <td class="text-center"><a href="#"><i class="fas fa-plus" @click="onAddCond()"></i></a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  
  <div class="row border bg-light mb-3">
    <div class="col-12 fw-bold fst-italic text-primary fs-5">Processor Routings</div>
    <div class="col">
      <table  class="table table-sm table-bordered">
        <thead class="table-dark small">
          <tr>
            <th width="15%">Priority</th>
            <th width="20%">Processor ID</th>
            <th width="15%">Load Weight</th>
            <th width="20%">Daily Threshold</th>
            <th width="20%">Monthly Threshold</th>
            <th widht="10%">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(routing, index) in rule.procRoutings" :key="index">
            <td><input v-model="routing.priority" class="form-control form-control-sm" type="number" /></td>
            <td>
              <select v-model="routing.procId" class="form-control form-control-sm">
                <option v-for="proc in procList" :key="proc.procId" :value="proc.procId">{{proc.procId}}</option>
              </select>
            </td>
            <td><input v-model="routing.loadWeight" class="form-control form-control-sm" type="number" /></td>
            <td><input v-model="routing.dailyThresholds.successAmount" class="form-control form-control-sm" type="number" /></td>
            <td><input v-model="routing.monthlyThresholds.successAmount" class="form-control form-control-sm" type="number" /></td>
            <td class="text-center"><a href="#"><i class="fas fa-trash-alt" @click="onDelRouting(index)"></i></a></td>
          </tr>
          <tr>
            <td colspan="5">&nbsp;</td>
            <td class="text-center"><a href="#"><i class="fas fa-plus" @click="onAddRouting()"></i></a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  
  <div class="text-end">
    <button class="btn btn-secondary me-2" @click="onCancel()">Cancel</button>
    <button class="btn btn-primary" @click="onSave()">Save</button>
  </div>
  
</div>
</template>

<script>
import HelpersMixin from '../utils/HelpersMixin.js'
export default {
  name: 'MerchantProcRuleForm',
  mixins: [HelpersMixin],
  props: {
    mxa: Object,
    ruleObj: Object
  },
  data () {
    return {
      rule: { conditions: [], procRoutings: [{dailyThresholds: {}, monthlyThresholds: {}}]},
      procList: [],
      mode: 'update'
    }
  },
  mounted () {
    this.getProcList()
    if (this.ruleObj) {
      this.getRule()
      this.mode = 'update'
    } else {
      this.rule.merchantId = this.mxa.merchantId
      this.rule.accountId = this.mxa.accountId
      this.mode = 'create'
    }
  },
  methods: {
    getRule: function () {
      this.axios.get('/ax/merchantprocrule/' + this.ruleObj.hashKey + "/" + this.ruleObj.ruleId)
      .then(response => {
        this.rule = response.data
      })
      .catch(error => this.handleError(error))
    },
    onSave: function () {
      this.rule.merchantId = this.mxa.merchantId
      this.rule.accountId = this.mxa.accountId
      this.rule.sortedRoutings =  null
      if (this.mode === 'create') {
        this.axios.put('/ax/merchantprocrule/', this.rule)
        .then(response => {
          this.rule = response.data
          this.$emit('saved')
        })
        .catch(error => this.handleError(error))
      } else {
        this.axios.post('/ax/merchantprocrule/', this.rule)
        .then(response => {
          this.rule = response.data
          this.$emit('saved')
        })
        .catch(error => this.handleError(error))
      }
    },
    onCancel: function () {
      this.$emit('cancelled')
    },
    onAddCond: function () {
      this.rule.conditions.push({ attrName: '', condType: 'EQ', condValue: '' })
    },
    onDelCond: function (idx) {
      this.rule.conditions.splice(idx, 1)
    },
    onAddRouting: function () {
      this.rule.procRoutings.push({priority: 0, procId: '', loadWeight: 0, dailyThresholds: {successAmount: 0}, monthlyThresholds: {successAmount: 0}})
    },
    onDelRouting: function (idx) {
      this.rule.procRoutings.splice(idx, 1)
    },
    getProcList: function () {
      this.axios.get('/ax/tpattribs/procinfolist')
      .then(response => {
        this.procList = response.data
      })
      .catch(error => this.handleError(error))
    }

  }
}
</script>